// extracted by mini-css-extract-plugin
module.exports = {"container":"settings-card_container__9jPZL","title":"settings-card_title__2a6Q9"};